import { render, staticRenderFns } from "./contract_text_de.vue?vue&type=template&id=09cfd30e&scoped=true"
import script from "./contract_text_de.vue?vue&type=script&lang=js"
export * from "./contract_text_de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cfd30e",
  null
  
)

export default component.exports